﻿window.mGetSondageConsolide = function (bddRef, dataSondage, dataSondageReponse, funcOk) {
    if (dataSondageReponse) {
        funcOk(new cSondageConsolide(dataSondage, dataSondageReponse, null))
    } else {
        bddRef.mAjaxCall({
            command: "getdatasondageconsolide",
            id_sondage: dataSondage.id_sondage
        }, function (data) {
            if (!data.lst_sondage_reponse) data.lst_sondage_reponse = []
            funcOk(new cSondageConsolide(dataSondage, null, data.lst_sondage_reponse))
        });
    }

}

window.cSondageConsolide = function (dataSondage, dataSondageReponse, lstDataSondageReponse) {
    var Me = this

    this.lstPage = JSON.parse(dataSondage.jsonquestion).lst_page
    this.lstPage.push(JSON.parse(dataSondage.jsonfin))
    this.lstDataSondageReponse = (dataSondageReponse ? [dataSondageReponse] : lstDataSondageReponse)
    this.isUnitaire = (typeof dataSondageReponse != 'undefined' && dataSondageReponse != null)

    var seulementFinalise = !this.isUnitaire
    this.getSeulementFinaliseValue = function (value) {
        if (typeof value != 'undefined') {
            seulementFinalise = value
            mInitLstReponse()
        }
        return seulementFinalise
    }
    var dateRef = null
    this.getDateRef = function (value) {
        if (!dateRef) {
            dateRef = {
                date_debut: this.minDate,
                date_fin: this.maxDate
            }
        }
        if (typeof value != 'undefined') {
            dateRef = value
            mInitLstReponse()
        }
        return dateRef
    }

    var lstReponseGeneral = []
    function mInitLstReponse() {
        lstReponseGeneral = []
        Me.lstDataSondageReponse.forEach(function (dataSondageReponse) {
            if (!seulementFinalise || (seulementFinalise && dataSondageReponse.finalise == "1")) {
                if (dateRef == null || (dataSondageReponse.dcr >= dateRef.date_debut && dataSondageReponse.dcr <= dateRef.date_fin)) {
                    if (dataSondageReponse.jsonreponse.length == 0) dataSondageReponse.jsonreponse = "[]"
                    JSON.parse(dataSondageReponse.jsonreponse).forEach(function (reponse) {
                        reponse.id_sondage_reponse = dataSondageReponse.id_sondage_reponse
                        lstReponseGeneral.push(reponse)
                    })
                }
            }
        })
    }
    mInitLstReponse()

    this.nbQuestion = 0
    this.lstPage.forEach(function (page) { Me.nbQuestion += page.lst_question.filter(function (o) { return o.type != "text" }).length })

    this.nbRepondantTotal = function () {
        return Me.lstDataSondageReponse.filter(function (o) { return (dateRef == null || (o.dcr >= dateRef.date_debut && o.dcr <= dateRef.date_fin)) }).length
    }
    this.nbRepondantFinalise = function () {
        return Me.lstDataSondageReponse.filter(function (o) { return (dateRef == null || (o.dcr >= dateRef.date_debut && o.dcr <= dateRef.date_fin)) && o.finalise == "1" }).length
    }

    // Extraire les dates dans un tableau
    var dates = Me.lstDataSondageReponse.map(function (item) {
        return item.dcr;
    });

    // Trouver la date minimale (la plus ancienne)
    this.minDate = null
    this.maxDate = null
    if (dates.length > 0) {
        this.minDate = new Date(Math.min.apply(null, dates.map(function (date) {
            return date.getTime();
        })));
        // Trouver la date maximale (la plus récente)
        this.maxDate = new Date(Math.max.apply(null, dates.map(function (date) {
            return date.getTime();
        })))
    }

    this.mGetTauxSatisfaction = function (question, page) {
        var lstQuestionSatisfaction = []
        this.lstPage.forEach(function (page) {
            lstQuestionSatisfaction = lstQuestionSatisfaction.concat(page.lst_question.filter(function (o) { return o.type == "radio" && o.calcul_satisfaction }))
        })
        if (lstQuestionSatisfaction.length == 0) {
            return {
                max: 100,
                value: 0,
                tx:0
            }
        } else {
            if (question) {
                var lstReponse = mGetLstReponseFromQuestion(question)
                return mGetDataSatisfactionQuestion(question, lstReponse)
            } else if (page) {
                var lstReponse = mGetLstReponseFromPage(page)
                return mGetDataSatisfactionPage(page, lstReponse)
            } else {
                var result = { max: 0, value: 0 }
                lstQuestionSatisfaction.forEach(function (question) {
                    var lstReponse = mGetLstReponseFromQuestion(question)
                    var satis = mGetDataSatisfactionQuestion(question, lstReponse)
                    result.max += satis.max
                    result.value += satis.value
                })
                result.tx = (result.max === 0 ? 0 : Math.round((result.value / result.max * 100) * 100) / 100)
                return result
            }
        }
    }

    this.mGetDataQuestion = function (question) {
        var lstReponse = mGetLstReponseFromQuestion(question)
        var dataSource = null
        switch (question.type) {
            case "ouinon":
                dataSource = mGetDataReponseOuiNon(question, lstReponse)
                break;
            case "chk":
                dataSource = mGetDataReponseChk(question, lstReponse)
                break;
            case "radio":
                dataSource = mGetDataReponseRadio(question, lstReponse)
                break;
            case "textbox":
                dataSource = mGetDataReponseTextbox(question, lstReponse)
                break;
            case "text":
                break;
        }
        return dataSource
    }

    function mGetDataReponseOuiNon(question, lstReponse) {
        var lstPhrase = [{ txt: "Oui", nb: 0 }, { txt: "Non", nb: 0 }]
        lstReponse.forEach(function (o) {
            if (typeof o.value != 'undefined') {
                lstPhrase[0].nb += (o.value ? 1 : 0)
                lstPhrase[1].nb += (o.value ? 0 : 1)
            }
        })
        return {
            dataSource: lstPhrase,
            nb_repondant: lstReponse.filter(function (o) { return typeof o.value != 'undefined' }).length
        }
    }

    function mGetDataReponseChk(question, lstReponse) {
        var lstPhrase = JSON.parse(JSON.stringify(question.lst_phrase))
        lstPhrase.forEach(function (ph) { ph.nb = 0 })
        lstReponse.forEach(function (rep) {
            if (rep.value) {
                rep.value.forEach(function (idPhrase, idx) {
                    var phEnCours = lstPhrase.filter(function (o) { return o.id_phrase == idPhrase })[0]
                    if (phEnCours) {
                        if (question.order_reponse) {
                            phEnCours.nb += rep.value.length - idx
                        } else {
                            phEnCours.nb += 1
                        }
                    }
                })
            }
        })
        lstPhrase.forEach(function (ph) { ph.txt = "(" + ph.nb + ") " + ph.txt })
        lstPhrase = lstPhrase.sort(function (o1, o2) { return o2.nb - o1.nb })

        return {
            dataSource: lstPhrase,
            nb_repondant: lstReponse.filter(function (o) { return typeof o.value != 'undefined' }).length
        }
    }

    function mGetDataReponseRadio(question, lstReponse) {
        var lstPhrase = JSON.parse(JSON.stringify(question.lst_phrase))
        lstPhrase.forEach(function (ph) { ph.nb = 0 })
        lstReponse.forEach(function (rep) {
            if (typeof rep.value != 'undefined' && rep.value != null) {
                var phEnCours = lstPhrase.filter(function (o) { return o.id_phrase == rep.value })[0]
                if (phEnCours) {
                    phEnCours.nb += 1
                }
            }
        })
        lstPhrase.forEach(function (ph) {
            ph.name = "(" + ph.nb + ") " + ph.txt
            ph.value = ph.nb
        })
        lstPhrase = lstPhrase.sort(function (o1, o2) { return o2.nb - o1.nb })

        var result = {
            dataSource: lstPhrase,
            nb_repondant: lstReponse.filter(function (o) { return typeof o.value != 'undefined' }).length
        }

        if (question.calcul_satisfaction) {
            result.satisfaction = mGetDataSatisfactionQuestion(question, lstReponse)
        }

        return result
    }

    function mGetDataSatisfactionQuestion(question, lstReponse) {
        var max = 0
        var value = 0
        lstReponse.forEach(function (rep) {
            if (typeof rep.value != 'undefined' && rep.value != null) {
                var item = question.lst_phrase.filter(function (o) { return o.id_phrase == rep.value })[0]
                if (item) {
                    max += question.lst_phrase.length - 1
                    value += question.lst_phrase.length - 1 - question.lst_phrase.indexOf(item);
                }
            }
        })
        return {
            max: max,
            value: value,
            tx: (max === 0 ? 0 : Math.round((value / max * 100) * 100) / 100)
        }
    }

    function mGetDataSatisfactionPage(page, lstReponse) {
        var max = 0
        var value = 0
        var lstQuestion = Me.lstPage.filter(function (o) { return o.id_page == page.id_page })[0].lst_question
        lstReponse.forEach(function (rep) {
            if (typeof rep.value != 'undefined' && rep.value != null) {
                var lstPhrase = lstQuestion.filter(function (o) { return o.id_question == rep.id_question })[0].lst_phrase
                var item = lstPhrase.filter(function (o) { return o.id_phrase == rep.value })[0]
                if (item) {
                    max += lstPhrase.length - 1
                    value += lstPhrase.length - 1 - lstPhrase.indexOf(item);
                }
            }
        })
        return {
            max: max,
            value: value,
            tx: (max === 0 ? 0 : Math.round((value / max * 100) * 100) / 100)
        }
    }

    function mGetDataReponseTextbox(question, lstReponse) {
        var phrase = {
            nb: 0,
            lstReponse: [],
            resume: "",
            nb_repondant: lstReponse.filter(function (o) { return typeof o.value != 'undefined' && o.value != null && o.value.length > 0 }).length
        }
        lstReponse.forEach(function (rep, idx) {
            if (typeof rep.value != 'undefined' && rep.value != null && rep.value.length > 0) {
                phrase.nb += 1
                phrase.lstReponse.push(rep)
                var dataSondageReponse = Me.lstDataSondageReponse.filter(function (o) { return o.id_sondage_reponse == rep.id_sondage_reponse })[0]
                phrase.resume += "<b>Réponse " + (dataSondageReponse && dataSondageReponse.libclient && dataSondageReponse.libclient.length > 0 ? dataSondageReponse.libclient : '(aucun contact)') + "</b><br/>" + rep.value + "<br/>"
            }
        })
        return phrase
    }

    function mGetLstReponseFromQuestion(question) {
        //reponse = {
        //    id_page: idPage,
        //    id_question: idQuestion,
        //    value: value
        //}
        return lstReponseGeneral.filter(function (sondageRep) {
            return sondageRep.id_page == question.id_page && sondageRep.id_question == question.id_question
        })
    }

    function mGetLstReponseFromPage(page) {
        //reponse = {
        //    id_page: idPage,
        //    id_question: idQuestion,
        //    value: value
        //}
        return lstReponseGeneral.filter(function (sondageRep) {
            return sondageRep.id_page == page.id_page
        })
    }
}